import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { LeftIcon, RightIcon } from 'foundations-assets';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Fragment, useMemo } from 'react';
//@ts-expect-error Could not find declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import UsageTracker from '../../utils/UsageTracker';
import SectionHeading from '../SectionHeading';
import { RouterLink } from '../AcademyLinks';
import { View } from 'foundations-components/components/View';
import { getMyLearningUrl } from '../../features/myLearning/myLearningRouting';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MostPopularCertificatesHeader = ({
  numCompletedCertificates
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const certificatesCompletedCount = useMemo(() => /*#__PURE__*/_jsx(RouterLink, {
    onClick: () => UsageTracker.track('interaction', {
      action: 'most-popular-certificates-certificates-completed-clicked'
    }),
    to: `${getMyLearningUrl()}?progressStatus=COMPLETED&awardType=ONLY_SHOW_CERTIFICATE_COURSES`,
    children: !isMobile && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.mostPopularCertificates.certificatesCompleted",
      options: {
        numCertificates: numCompletedCertificates
      }
    })
  }), [isMobile, numCompletedCertificates]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(TFlex, {
      align: "start",
      justify: "between",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        icon: true,
        subText: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.mostPopularCertificates.genericSubtitle"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.mostPopularCertificates.genericTitle"
        })
      }), !isMobile && /*#__PURE__*/_jsxs("div", {
        style: {
          display: 'flex'
        },
        children: [certificatesCompletedCount, /*#__PURE__*/_jsxs("div", {
          style: {
            display: 'none'
          },
          children: [/*#__PURE__*/_jsx(IconButton, {
            size: "xs",
            children: /*#__PURE__*/_jsx(LeftIcon, {})
          }), /*#__PURE__*/_jsx(IconButton, {
            size: "xs",
            children: /*#__PURE__*/_jsx(RightIcon, {})
          })]
        })]
      })]
    }), isMobile && /*#__PURE__*/_jsx(View, {
      as: "div",
      marginBlockEnd: "200",
      children: certificatesCompletedCount
    })]
  });
};
export default MostPopularCertificatesHeader;